import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { Button } from "../../atoms";

export const Container = styled.header<{ $chromeless?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[4]};
  box-sizing: border-box;

  ${({ $chromeless, theme }) =>
    !$chromeless &&
    css`
      background-color: ${theme.colors.surface.primary};
      border: ${theme.borders.width[1]} ${theme.borders.style.solid}
        ${theme.colors.border.subtle};
      border-radius: ${theme.borders.radius.lg};
      padding: ${theme.spacing.component.card.padding.sm}
        ${theme.spacing.component.card.padding.md};
    `}
`;

export const Identity = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  min-width: 0;
`;

export const NameGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Name = styled.h1`
  ${typographyMixin("subtitle", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  flex-shrink: 0;
`;

/**
 * Header action buttons sit on a card surface, so the primitive's default
 * shadow + hover-lift would feel heavy. Flatten them here, and lighten the
 * text from the Button primitive's semibold default to medium so the row
 * matches the Figma's lighter weight, without changing the shared Button.
 */
export const HeaderButton = styled(Button)`
  ${typographyMixin("body", 3)}
  border-radius: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[4]};

  &,
  &:hover:not(:disabled),
  &:active:not(:disabled),
  &:focus-visible {
    box-shadow: none;
    transform: none;
  }

`;
